import axios, { CreateAxiosDefaults } from 'axios';
import { getEnvironmentVar } from '../shared/utils/getEnvironmentVar';

export const govosBaseUrl = getEnvironmentVar('REACT_APP_GOVOS_URL') || '';

const govosDesktopApiUrl = `${govosBaseUrl}/portal/desktop/0/api1`;

/**
 * Some API Endpoints like /verfahren are indepent from an startApp and therefore do not need a startAppId in theory, but due to our current impelementation it is required.
 * Most of the endpoints can be called with the static startAppId or rather without an id to be indepent from an startApp and mandant friendly.
 */
export const GovosApiRoutes = {
  login: () => `${govosDesktopApiUrl}/login`,
  logout: () => `${govosDesktopApiUrl}/logout`,
  user: () => `${govosDesktopApiUrl}/user`,
  resetPassword: () => `${govosDesktopApiUrl}/passwd`,
  products: () => `${govosDesktopApiUrl}/products`
};

axios.defaults.baseURL = govosBaseUrl;

export const apiConfig: CreateAxiosDefaults = {
  baseURL: govosBaseUrl,
  withCredentials: true
};

export const govosClient = axios.create(apiConfig);
